/**
 * 全局数据模型
 */

export default {
  /**用户信息 */
  userInfo: {
    avatar: "",
    nickname: "",
    uuid: "",
    ticket: "",
    mobile: "",
    avatarFrameType: "",
    vipinfo: {},
  },
  /**设备信息 */
  deviceInfo: {},
  /**芒果卡身份 0表示非芒果卡用户；1表示普通芒果卡用户；2表示VIP芒果卡用户*/
  identity: 0,
};
